<template>
    <b-modal ref="mdlNuovaVoce" size="lg" :title="titoloModal" @hidden="onCloseModal" @ok="onClickOk" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div>
            <b-card class="sa-card" header="Dettaglio" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Codice:</label>
                        <b-form-input v-model="jsonData.codice" placeholder="Codice"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione:</label>
                        <b-form-input v-model="jsonData.descrizione" placeholder="Descrizione"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Capogruppo:</label>
                        <b-form-input v-model="jsonData.capogruppo" placeholder="Capogruppo"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <b-form-checkbox v-if="!nuovo" v-model="jsonData.attivo" name="check-button" switch>
                            <label class="sa-label-data">Attivo</label>
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-card>
            <modal-error ref="cmpModalError"></modal-error>
        </div>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
export default {
    components: { ModalError },
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            nuovo: true,
            pathResource: "/articoligruppi",
            pathResourceSezioneDizionario: "/dizionariosezioni",
            titoloModal: "",
            sezioneOptions: [{ value: "", text: "-Seleziona Valore-" }],
            jsonData: { codice: null, descrizione: null, capogruppo: null },
        };
    },
    methods: {
        openModal(item) {
            let me = this;
            me.$emit("beforloadData");
            if (item !== null) {
                me.titoloModal = "Modifica Gruppo";
                me.jsonData = item;
                me.nuovo = false;
            } else {
                me.titoloModal = "Aggiungi Gruppo";
                me.nuovo = true;
                me.jsonData = { codice: null, descrizione: null, capogruppo: null };
            }
            me.$refs.mdlNuovaVoce.show();
            me.$emit("afterLoadData");
        },
        onCloseModal() {
            let me = this;
            me.$emit("beforloadData");
            me.jsonData = { codice: null, descrizione: null, capogruppo: null };
            me.$emit("afterLoadData");
        },
        onClickOk(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("afterSaveSuccess", response);
            me.$emit("afterLoadData");
            me.$refs.mdlNuovaVoce.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            this.$emit("afterLoadData");
        },
    },
};
</script>
